import { Nomenclature } from './Nomenclature';
import {FrxBaseBean} from './frxbasebean';
export class Izpulnitelno extends FrxBaseBean {
	'number': string;
	izpulnitelenListNomer: string;
	chsi: Nomenclature;
	status: Nomenclature;

	copy(source: Izpulnitelno) {
		super.copy(source);
		this.izpulnitelenListNomer = source.izpulnitelenListNomer;
		this.chsi = source.chsi;
		this.status = source.status;
		this.chsi = source.chsi;
		this.status = source.status;
		this.number = source.number;

	}
}
